import { render, staticRenderFns } from "./ZjxxTable.vue?vue&type=template&id=96de0270&scoped=true"
import script from "./ZjxxTable.vue?vue&type=script&lang=js"
export * from "./ZjxxTable.vue?vue&type=script&lang=js"
import style0 from "./ZjxxTable.vue?vue&type=style&index=0&id=96de0270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96de0270",
  null
  
)

export default component.exports